export default {
  name: "v-side-modal-button",
  props: {
    svgIcon: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: false
    },
    link: {
      type: String,
      required: false
    },
    customClass: {
      type: String,
      required: false,
      default: ''
    }
  }
};